import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const noteCompletionState = (state: RootState) => state.scene.dashboard.noteCompletionState;

export const getNoteCompletionDrillDownViewState = createSelector(
  noteCompletionState,
  ({ viewState }) => viewState
);

export const getNoteCompletionDrillDownTotalFilteredRecords = createSelector(
  noteCompletionState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getNoteCompletionDrillDownTotalRecords = createSelector(
  noteCompletionState,
  ({ totalRecords }) => totalRecords
);

export const getNoteCompletionDrillDownCustomDateRange = createSelector(
  noteCompletionState,
  ({ drillDownCustomDateRange }) => drillDownCustomDateRange
);

export const getNoteCompletionDrillDownConfiguration = createSelector(
  noteCompletionState,
  ({ configuration }) => configuration
);

export const isNoteCompletionDrillDownLoading = createSelector(
  noteCompletionState,
  ({ loading }) => loading
);
